module.exports = __webpack_public_path__ + "static/media/chords.8ba88965.mp3";